export default {
    data: () => ({
        postTitle: "",
        postDescription: "",
        postValid: false,
        tags: []
    }),
    
    methods: {
        /* 
         * Photo handlers
         */
        managePhotos(files) {
            // On upload media event
            this.$emit('photosAdded', files)
        },
        deletePhoto(id) {
            // on delete media event
            this.$emit('deletePhoto', id)
        },

        updatePhoto(payload) {
            // On update media event
            this.$emit('updatePhoto', payload)
        },

        /* 
         * Form Handlers
         */
        sendPost() {
            if (this.$refs.postUploadForm.validate()) {
                // on post validation
                this.$emit('formValidated', {
                    title: this.postTitle,
                    description: this.postDescription
                })
            }
        },

        /*
         * Tags
         */
        removeTag(item) {
            const index = this.tags.indexOf(item.name)
            if (index >= 0) this.tags.splice(index, 1)
        }
    }
}